var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogoShort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 54 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.974 24.805L2.326 36.674c.358 1.49.778 3.01 1.27 4.552l23.378-11.257 23.38 11.257a65.066 65.066 0 001.268-4.552l-24.648-11.87z",
    fill: "var(--a, #000)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.324 45.968a58.37 58.37 0 001.942 4.228l19.71-9.49 19.71 9.491a58.567 58.567 0 001.941-4.228L26.975 35.543 5.325 45.968z",
    fill: "var(--a, #000)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.974 46.277l-17.23 8.297c3.934 6.272 9.47 12.301 17.23 17.294 7.76-4.993 13.296-11.022 17.23-17.294l-17.23-8.297zM53.12 12.829L26.976.305.827 12.829s-1.25 8.05.48 18.762l25.667-12.36 25.666 12.36c1.73-10.711.48-18.762.48-18.762z",
    fill: "var(--a, #000)"
  })));
}

export default SvgLogoShort;